// src/stores/actions/activity.js
export const LIST_ACTIVITIES = 'activity.LIST_ACTIVITIES'
export const CREATE_ACTIVITY = 'activity.CREATE_ACTIVITY'

// Lista atividades (opcional para usar na tela agora ou depois)
export const listActivities = (params, callback) => ({
  type: LIST_ACTIVITIES,
  params,
  callback,
})

// Cria atividade
export const createActivity = (data, callback) => ({
  type: CREATE_ACTIVITY,
  data,
  callback,
})
